module.exports = __webpack_public_path__ + "static/media/Gotham-Light.9249716e.ttf";